// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as NewFlightActions } from '../../new-flight/duck';
import { actions as AlertActions } from '../../alert/duck';
import { actions as SecurityPasswordActions } from '../../preferences/security/duck';
import NewFlight from '../components/NewFlight';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    locale: state.locale,
    localValues: state.localValues,
    isPosting: state.newFlight.isPosting,
    postError: state.newFlight.postError,
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    chosenVariants: state.abTest.chosenVariants,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...NewFlightActions, ...AlertActions, ...SecurityPasswordActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NewFlight);



// WEBPACK FOOTER //
// ./src/modules/new-flight/containers/NewFlightContainer.js